/* eslint-disable @typescript-eslint/naming-convention */
import dialog from '../components/dialog/dialog.vue';
import load from './core/load';
// import load from './core/load.js';
const _dialog = load(dialog);

interface BusinessDialogConfigItem {
  content: string;
  btns: Array<{ text: string; click: Function }>;
}
type BusinessDialogConfig = { [key: string]: BusinessDialogConfigItem };
interface DialogError extends Partial<Error> {
  retmsg?: string;
}

interface CommonDialogParams {
  title?: string;
  htmlContent?: string;
  content?: string;
  theme?: string;
  btns?: Array<{ text: string; click?: Function }>;
  weui?: boolean;
  valignBtn?: boolean;
  closeBtn?: boolean;
  autoClose?: boolean;
  hidden?: boolean;
}

/**
 * 业务弹窗配置,从外部设置
 */
let businessDialogConfig: BusinessDialogConfig = {};

function setBusinessDialogConfig(config: BusinessDialogConfig) {
  businessDialogConfig = config;
}

/**
 * 业务弹窗
 * @param err 错误内容，支持请求返回的错误或者自定义错误
 */
function showErrorDialog(err?: DialogError) {
  // 弹窗通用配置
  const msg = err?.retmsg || err?.message;
  const baseErrorDialog = {
    content: msg || '網絡異常，請稍後重試',
    weui: true,
    btns: [
      {
        text: '確認',
      },
    ],
  };
  // 业务弹窗
  let bussinessDialog = {};
  if (err && Object.keys(businessDialogConfig).includes(err.message || err.name || '')) {
    bussinessDialog = businessDialogConfig[err.message || err.name || ''];
  }

  _dialog.show(Object.assign(baseErrorDialog, bussinessDialog));
}

function hideErrorDialog() {
  _dialog.hide();
}

/**
 * 展示普通弹窗
 * @param params 普通弹窗参数
 */
function showCommonDialog(params: CommonDialogParams) {
  _dialog.show(params);
}

/**
 * 隐藏普通弹窗
 */
function hideCommonDialog() {
  _dialog.hide();
}

export { showErrorDialog, hideErrorDialog, setBusinessDialogConfig, showCommonDialog, hideCommonDialog };
